import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Access } from '@prisma/client';
import { Tag, Typography } from 'antd';

import { AgsRoleMeta } from '@app/domain-access-interfaces';

export type AgsAccessNameRendererProps = {
  agsAccess: Access;
};
export const AgsAccessNameRenderer = ({ agsAccess }: AgsAccessNameRendererProps) => {
  const { name, isActive } = agsAccess;
  const meta = agsAccess.meta as AgsRoleMeta;
  return (
    <>
      <div>{name.replace(/ /g, '\u00a0')}</div>
      {name && isActive && meta?.displayName && name !== meta.displayName && (
        <Typography.Text type="secondary">a.k.a. {meta.displayName.replace(/ /g, '\u00a0')}</Typography.Text>
      )}
      {!isActive && (
        <Tag icon={<ExclamationCircleOutlined />} color="error">
          Not found in AGS, likely no longer in use.
        </Tag>
      )}
    </>
  );
};
